import { NgModule, inject } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PreventBackButtonGuard } from './guards/prevent-back-button.guard';

const routes: Routes = [

  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    canDeactivate: [() => inject(PreventBackButtonGuard).canDeactivate()],
    loadChildren: () => import('./pages/auth/auth.module').then( m => m.AuthModule)
  },
  {
    path: 'operations',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/operations-page/operations.module').then(
        (m) => m.OperationsPageModule
      )
  },
  {
    path: 'ap-operations',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/ap-operations-page/ap-operations.module').then(
        (m) => m.AutopilotOperationsPagePageModule
      )
  },
  {
    path: 'fleet',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/fleet/fleet.module').then(
        (m) => m.FleetPageModule
      )
  },
  {
    path: 'vehicle-form',
    canActivate: [() => inject(AuthGuard).canActivate()],
    canDeactivate: [() => inject(PreventBackButtonGuard).canDeactivate()],
    loadChildren: () =>
      import('./pages/vehicle-form/vehicle-form.module').then(
        (m) => m.VehicleFormPageModule
      )
  },
  {
    path: 'pilot-form',
    canActivate: [() => inject(AuthGuard).canActivate()],
    canDeactivate: [() => inject(PreventBackButtonGuard).canDeactivate()],
    loadChildren: () =>
      import('./pages/pilot-form/pilot-form.module').then(
        (m) => m.PilotFormPageModule
      )
  },
  {
    path: 'operator-form',
    canActivate: [() => inject(AuthGuard).canActivate()],
    canDeactivate: [() => inject(PreventBackButtonGuard).canDeactivate()],
    loadChildren: () =>
      import('./pages/operator-form/operator-form.module').then(
        (m) => m.OrganizationFormPageModule
      )
  },
  {
    path: 'logbook',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/logbooks/logbooks.module').then(
        (m) => m.LogbooksPageModule
      )
  },
  {
    path: 'region-maps',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/region-maps-page/region-maps.module').then(
        (m) => m.RegionMapsPageModule
      )
  },
  {
    path: 'planning',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/planning-page/planning.module').then(
        (m) => m.PlanningPageModule
      )
  },
  {
    path: 'relay',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/relay-page/relay.module').then(
        (m) => m.RelayPageModule
      )
  },
  {
    path: 'schedule',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/scheduled-operations-page/schedule.module').then(
        (m) => m.ScheduleModule
      )
  },
  {
    path: 'new-trajectories-page',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/new-trajectories-page/new-trajectories.module').then(
        (m) => m.NewTrajectoriesPageModule
      )
  },
  {
    path: 'create-trajectory',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/create-trajectory/create-trajectory.module').then(
        (m) => m.CreateTrajectoryPageModule
      )
  },
  {
    path: 'details',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/details-page/details.module').then(
        (m) => m.DetailsPageModule
      )
  },
  {
    path: 'battery-charging-register/:serialNumber',
    canActivate: [() => inject(AuthGuard).canActivate()],
    loadChildren: () =>
      import('./pages/battery-charging-register/battery-charging-register.module').then(
        (m) => m.BatteryChargingRegisterPageModule
      )
  },
  {
    path: 'reset-password/:token',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule),
  },
  {
    path: 'enrolment',
    canDeactivate: [() => inject(PreventBackButtonGuard).canDeactivate()],
    loadChildren: () => import('./pages/enrolment/enrolment.module').then( m => m.EnrolmentPageModule)
  },
  {
    path: '**',
    loadChildren: () => import('./pages/auth/auth.module').then( m => m.AuthModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
